import * as z from 'zod';

// Trim and lowercase run before the format check, so "  Foo@Example.COM " is accepted and
// normalized rather than rejected for its whitespace.
export const PortalRouterLookupInput = z.object({
  email: z.string().trim().toLowerCase().pipe(z.email().max(254)),
});
export type PortalRouterLookupInput = z.infer<typeof PortalRouterLookupInput>;

export const PortalRouterMatch = z.object({
  name: z.string(),
  hostname: z.string(),
  loginUrl: z.url(),
  logoUrl: z.url().optional(),
});
export type PortalRouterMatch = z.infer<typeof PortalRouterMatch>;

export const PortalRouterLookupResponse = z.object({
  portals: z.array(PortalRouterMatch),
});
export type PortalRouterLookupResponse = z.infer<typeof PortalRouterLookupResponse>;

export const PortalRouterRateLimitedResponse = z.object({
  code: z.literal('RATE_LIMITED'),
  retryAfterSeconds: z.number().int().positive(),
});
export type PortalRouterRateLimitedResponse = z.infer<typeof PortalRouterRateLimitedResponse>;

export const PortalRouterInvalidEmailResponse = z.object({
  code: z.literal('INVALID_EMAIL'),
});
export type PortalRouterInvalidEmailResponse = z.infer<typeof PortalRouterInvalidEmailResponse>;
